import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, MapPin } from "lucide-react";
// import { heroImages } from "../data/heroImages"; // adjust path if needed
import srimg1 from '../assets/SuiteRoom/one.webp'
import srimg2 from "../assets/SuiteRoom/two.webp";
import srimg3 from "../assets/SuiteRoom/three.webp";
import srimg4 from "../assets/SuiteRoom/four.webp";
import srimg5 from "../assets/SuiteRoom/five.webp";
import srimg6 from "../assets/SuiteRoom/six.webp";
import srimg7 from "../assets/SuiteRoom/seven.webp";
import srimg8 from "../assets/SuiteRoom/eight.webp";
export default function HeroCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
const heroImages=[srimg1,
      srimg2,
      srimg3,
      srimg4,
      srimg5,
      srimg6,
      srimg7,
      // srimg8,
     ]
  // Auto-play every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % heroImages.length);

  return (
    <div className="relative h-96 md:h-screen overflow-hidden">
      {/* Carousel Images - from your array */}
      {heroImages.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Karuna Regent - View ${index + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      {/* Dark overlay (common for all slides) */}
      <div className="absolute inset-0 bg-black bg-opacity-40" />

      {/* Your original content - unchanged */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white px-6">
          <h2 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-2xl">
            Welcome to Karuna Regent
          </h2>
          <p className="text-xl md:text-2xl mb-6 font-light tracking-wider drop-shadow-lg">
            Experience Comfort & Elegance in Chennai
          </p>
          <div className="flex items-center justify-center gap-3 text-lg">
            <MapPin className="w-6 h-6" />
            <span>Saligramam, Chennai, Tamil Nadu</span>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 backdrop-blur p-3 rounded-full transition"
      >
        <ChevronLeft className="w-8 h-8" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 backdrop-blur p-3 rounded-full transition"
      >
        <ChevronRight className="w-8 h-8" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`transition-all ${
              index === currentIndex
                ? "w-12 h-3 bg-white rounded-full"
                : "w-3 h-3 bg-white/60 rounded-full hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  );
}